<template>
  <div class="correlation-map">
    <div class="svg-frame"></div>
  <v-btn x-small @click="toggleScale">Toggle Scale</v-btn>
  {{scaleLinear}}
  </div>
</template>

<script>
import * as d3 from "d3"
import _ from "lodash"
import moment from "moment"


let random = (min, max) => Math.floor(Math.random()*(max-min+1)+min)

export default {
  data: () => ({
    scaleLinear: true,
    update: null,
  }),
  methods: {
    toggleScale() {
      this.scaleLinear = !this.scaleLinear
      if (this.update) {
        this.update()
      }
    },
    async render() {
      
      console.log("rendering")
      // set the dimensions and margins of the graph
      var margin = {top: 10, right: 20, bottom: 30, left: 50},
          width = 500 - margin.left - margin.right,
          height = 420 - margin.top - margin.bottom;

      // append the svg object to the body of the page
      console.log(d3.select(".svg-frame"))
      var svg = d3.select(".svg-frame")
        .append("svg")
          .attr("width", width + margin.left + margin.right)
          .attr("height", height + margin.top + margin.bottom)
        .append("g")
          .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")");
      
      //Read the data
      let promises = [];
      let data;
      let casesData;
      let reopeningData;
      promises.push(
        d3.csv("https://raw.githubusercontent.com/holtzy/data_to_viz/master/Example_dataset/4_ThreeNum.csv")
          .then(res => (data = res))
      )
      
      let reopeningDataJson = "https://testsites.millionpatientscured.com:5000/api/Mandate/formatted"
      promises.push(
        d3.json(reopeningDataJson).then(res => (reopeningData = res))
      )
      
      promises.push(
        d3
          .csv(
            "https://raw.githubusercontent.com/nytimes/covid-19-data/master/us-counties.csv"
          )
          .then(res => (casesData = res))
      )

      await Promise.all(promises)

      let sum = (a, b) => a + b

      
      // add county full name in each record
      casesData.forEach(d => {
        d.fullName = `${d.county}{areaName}, ${d.state}`
      })

      
      // Calculate active cases
      // Calculate 7day active dif
      let getAvg = nums => {
        const sum = nums.reduce((a, b) => a + b, 0)
        const avg = sum / nums.length || 0
        return avg
      }
      let getSum = nums => {
        const sum = nums.reduce((a, b) => a + b, 0)
        return sum
      }
      let calc = (() => {
        let b
        let x = {
          sum: 0,
          doubleSum: 0,
          pastSum: 0,
          avg: 0,
          // pastAvg: 0,
          
          init(base) {
            b = base,
            values = []
            x.sum = 0
            x.doubleSum = 0
            x.pastSum = 0
            x.avg = 0
            // x.pastAvg = 0
          },
          add(v) {
            values.push(v)
            x.sum += v
            x.doubleSum += v
            if (values.length > b) {
              x.sum -= values[values.length - 1 - b]
              if (values.length > 2*b) {
                x.doubleSum -= values[values.length - 1 - 2*b]
              }
              // x.pastAvg = (x.doubleSum - x.sum)/Math.min(b, values.length - b)
            }
            x.avg = x.sum/Math.min(b, values.length)
            x.pastSum = x.doubleSum - x.sum
          },
        }
        let values = []

        return x
      })
      // calc.init(7)
      // calc.add(4)
      // calc.sum
      // calc.avg
      // calc.doubleSum
      let calcCases = calc()
      let calcDeaths = calc()
      _.each(_.groupBy(casesData, "fullName"), (arr, county) => {
        let casesByDate = _.orderBy(arr, ["date"], ["asc"])
        let pastCases = 0
        let pastDeaths = 0
        // let pastNCases = []
        // let pastNDeaths = []
        let dayAverage = 7
        calcCases.init(7)
        calcDeaths.init(7)
        casesByDate.forEach(d => {
          // dt = Date.now()
          d.newCases = d.cases - pastCases
          // time11 += Date.now() - dt
          // dt = Date.now()
          d.newDeaths = d.deaths - pastDeaths
          // time12 += Date.now() - dt
          // dt = Date.now()

          // d.activeCases = getSum(pastNCases.slice(-dayAverage * 2))
          // if (d.activeCases != calcCases.doubleSum()) debugg
          d.activeCases = calcCases.doubleSum

          // time13 += Date.now() - dt
          // dt = Date.now()

          // pastNCases.push(+d.newCases)
          // pastNDeaths.push(+d.newDeaths)

          // d.averageCases = getAvg(pastNCases.slice(-dayAverage))
          // if (d.averageCases != calcCases.avg) debugger
          d.averageCases = calcCases.avg
          // d.averageDeaths = getAvg(pastNDeaths.slice(-dayAverage))
          // if (d.averageDeaths != calcDeaths.avg) debugger
          d.averageDeaths = calcDeaths.avg

          calcCases.add(+d.newCases)
          calcDeaths.add(+d.newDeaths)

          // time2 += Date.now() - dt
          // dt = Date.now()
          
          // d.newCasesPeriod = getSum(pastNCases.slice(-dayAverage))
          // if (d.newCasesPeriod != calcCases.sum) debugger
          d.newCasesPeriod = calcCases.sum
          // let newCasesPastPeriod = getSum(
          //   pastNCases.slice(-dayAverage * 2, pastNCases.length - dayAverage)
          // )
          // if (newCasesPastPeriod != calcCases.pastSum) debugger
          let newCasesPastPeriod = calcCases.pastSum
          d.difCases = d.newCasesPeriod - newCasesPastPeriod
          d.difCasesPct = d.difCases / newCasesPastPeriod

          // time3 += Date.now() - dt
          // dt = Date.now()
          
          // d.newDeathsPeriod = getSum(pastNDeaths.slice(-dayAverage))
          // if (d.newDeathsPeriod != calcDeaths.sum) debugger
          d.newDeathsPeriod = calcDeaths.sum
          // let newDeathsPastPeriod = getSum(
          //   pastNDeaths.slice(-dayAverage * 2, pastNDeaths.length - dayAverage)
          // )
          // if (newDeathsPastPeriod != calcDeaths.pastSum) debugger
          let newDeathsPastPeriod = calcDeaths.pastSum
          d.difDeaths = d.newDeathsPeriod - newDeathsPastPeriod
          d.difDeathsPct = d.difDeaths / newDeathsPastPeriod



          // time4 += Date.now() - dt
          // dt = Date.now()
          
          // pastNCases = pastNCases.slice(-dayAverage * 2)
          // pastNDeaths = pastNDeaths.slice(-dayAverage * 2)

          pastCases = d.cases
          pastDeaths = d.deaths

          // time5 += Date.now() - dt
        })
      })
      let stateData = _.map(
        _.groupBy(casesData, "state"),
          (arr, state) =>
            _.map(_.groupBy(arr, "date"), (cases, date) => {
              let info = {
                state: state,
                date: date,
                activeCases: cases.map(d => +d.activeCases).reduce(sum, 0),
                cases: cases.map(d => +d.cases).reduce(sum, 0),
                deaths: cases.map(d => +d.deaths).reduce(sum, 0),
                newCases: cases.map(d => +d.newCases).reduce(sum, 0),
                newDeaths: cases.map(d => +d.newDeaths).reduce(sum, 0),
                averageCases: cases.map(d => +d.averageCases).reduce(sum, 0),
                averageDeaths: cases.map(d => +d.averageDeaths).reduce(sum, 0),
                newCasesPeriod: cases.map(d => +d.newCasesPeriod).reduce(sum, 0),
                newDeathsPeriod: cases.map(d => +d.newDeathsPeriod).reduce(sum, 0),
                difCases: cases.map(d => +d.difCases).reduce(sum, 0),
                difDeaths: cases.map(d => +d.difDeaths).reduce(sum, 0),
                minCases: Math.min(0, ...cases.map(d => +d.cases)),
                maxCases: Math.max(0, ...cases.map(d => +d.cases)),
                minDeaths: Math.min(0, ...cases.map(d => +d.deaths)),
                maxDeaths: Math.max(0, ...cases.map(d => +d.deaths)),
                minActiveCases: Math.min(0, ...cases.map(d => +d.activeCases)),
                maxActiveCases: Math.max(0, ...cases.map(d => +d.activeCases)),
                total: cases.map(d => +d.cases).reduce(sum, 0)
              }
              info.difCasesPct = info.difCases / (info.newCasesPeriod - info.difCases)
              info.difDeathsPct = info.difDeaths / (info.newDeathsPeriod - info.difDeaths)
              return info
            })
        ).flat()

      let stateCases = this.getStateCases(stateData, '2021-01-01')
      console.log(stateData)
      console.log(stateCases)

      let varx = d => d.activeCases
      let vary = d => random(35,90)
      let varz = d => 10
      // console.log(data)
      data = stateCases.byState.map(d => ({
        name: d.state,
        color: d.state,
        x: varx(d),
        y: vary(d),
        z: varz(d),
      }))
      // data.splice(0,130)
      // data.push(...data2)

      console.log(data)

      // let t =
      // Add X axis
      var x = d3.scaleLinear()
        .domain([0, Math.max(...data.map(d => d.x))])
        .range([ 0, width ]);
      svg.append("g")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(x));

      // Add Y axis
      var y = d3.scaleLinear()
        .domain([0, 100])
        .range([ height, 0]);
      svg.append("g")
        .call(d3.axisLeft(y));

      // Add a scale for bubble size
      var z = d3.scaleLinear()
        .domain([0, 1000])
        .range([ 4, 40]);

      // Add a scale for bubble color
      var myColor = d3.scaleOrdinal()
        .domain(["Asia", "Europe", "Americas", "Africa", "Oceania"])
        .range(d3.schemeSet2);

      // -1- Create a tooltip div that is hidden by default:
      var tooltip = d3.select(".svg-frame")
        .append("div")
          .style("opacity", 0)
          .attr("class", "tooltip")
          .style("background-color", "#eee")
          .style("border", "1px solid #33c")
          .style("border-radius", "3px")
          .style("padding", "10px")
          .style("color", "#333")

      // -2- Create 3 functions to show / update (when mouse move but stay on same circle) / hide the tooltip
      var showTooltip = function(d) {
        tooltip
          .transition()
          .duration(200)
        tooltip
          .style("opacity", 1)
          .html(d.name)
          .style("left", (d3.mouse(this)[0]+30) + "px")
          .style("top", (d3.mouse(this)[1]+30) + "px")
      }
      var moveTooltip = function(d) {
        tooltip
          .style("left", (d3.mouse(this)[0]+30) + "px")
          .style("top", (d3.mouse(this)[1]+30) + "px")
      }
      var hideTooltip = function(d) {
        tooltip
          .transition()
          .duration(200)
          .style("opacity", 0)
      }

      // Add dots
      svg.append('g')
        .selectAll("dot")
        .data(data)
        .enter()
        .append("circle")
          .attr("class", "bubbles")
          .attr("cx", function (d) { return x(d.x); } )
          .attr("cy", function (d) { return y(d.y); } )
          .attr("r", function (d) { return z(d.z); } )
          .style("fill", function (d) { return myColor(d.color); } )
        // -3- Trigger the functions
        .on("mouseover", showTooltip )
        .on("mousemove", moveTooltip )
        .on("mouseleave", hideTooltip )
    },

    getStateCases: function(data, date) {
      // filter by date
      let dates = data.map(d => d.date)
      dates = [...new Set(dates)] // uniq
      dates = dates.filter(d => moment(d).isSameOrBefore(date))
      dates.sort()
      let latest = dates[dates.length - 1]
      data = data.filter(d => d.date == latest)

      // set max cases by state in each record
      let maxActiveCasesCountry = Math.max(0, ...data.map(d => +d.activeCases))
      let maxCasesCountry = Math.max(0, ...data.map(d => +d.cases))
      let maxDeathsCountry = Math.max(0, ...data.map(d => +d.deaths))

      data.forEach(d => {
        d.activeCasesRelativeToCountry =
          maxActiveCasesCountry == 0
            ? 0
            : +d.activeCases / maxActiveCasesCountry
        d.casesRelativeToCountry =
          maxCasesCountry == 0 ? 0 : +d.cases / maxCasesCountry
        d.deathsRelativeToCountry =
          maxDeathsCountry == 0 ? 0 : +d.deaths / maxDeathsCountry
      })

      // let records = new Map(Array.from(data, d => [d.state, d]))

      return {
        maxActiveCasesCountry,
        maxCasesCountry,
        maxDeathsCountry,
        // byState: records
        byState: data
      }
    },
  },
  created() {
    setTimeout(() => {
      this.render()
    }, 0)
    window.d3 = d3
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.correlation-map {
  .bubbles {
    stroke-width: 2px;
    stroke: white;
  }
  .bubbles:hover {
    stroke: black;
  }
}
</style>
